import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { v4 as uuidv4 } from "uuid";

class PayrollSetupsFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();

    const id = this.object.id || uuidv4();

    if (this.object.id) {
      this.change.id = id;
    } else {
      this.change.id = id;
      this.change.acl = this.view.getAcl();
    }

    try {
      await this.upsertUseCase.execute(collection, this.change);
      await this.upsertUseCase.execute("setups_holder", {
        id,
      });

      this.showSuccess("Successfully Saved!");
      this.change = {};
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default PayrollSetupsFormPresenter;
